import React from "react";
import { formatArs, formatSignedArs } from "@/domain/projection/format";

export type BarItem = {
  label: string;
  value: number;
};

type ProjectionBarChartProps = {
  title: string;
  items: BarItem[];
  caption?: string;
};

export const ProjectionBarChart: React.FC<ProjectionBarChartProps> = ({ title, items, caption }) => {
  const max = Math.max(1, ...items.map((item) => Math.abs(item.value)));
  return (
    <div className="panel-card p-4">
      <h3 className="text-sm font-semibold text-slate-800 dark:text-slate-100">{title}</h3>
      <div className="mt-3 space-y-2.5">
        {items.map((item) => {
          const width = `${Math.max(2, (Math.abs(item.value) / max) * 100)}%`;
          const positive = item.value >= 0;
          return (
            <div key={item.label}>
              <div className="mb-1 flex items-center justify-between gap-2 text-xs">
                <span className="truncate text-slate-600 dark:text-slate-300">{item.label}</span>
                <span className={`tabular-nums font-medium ${positive ? "text-slate-800 dark:text-slate-100" : "text-rose-600 dark:text-rose-400"}`}>
                  {positive ? formatArs(item.value) : formatSignedArs(item.value)}
                </span>
              </div>
              <div className="h-2 overflow-hidden rounded-full bg-slate-100 dark:bg-gray-700">
                <div
                  className={`h-full rounded-full ${positive ? "bg-teal-500" : "bg-rose-500"}`}
                  style={{ width }}
                />
              </div>
            </div>
          );
        })}
      </div>
      {caption ? <p className="mt-3 text-[11px] text-slate-400">{caption}</p> : null}
    </div>
  );
};
